import { render } from "./ChallengeInfo.vue?vue&type=template&id=11749456&scoped=true"
import script from "./ChallengeInfo.vue?vue&type=script&lang=js"
export * from "./ChallengeInfo.vue?vue&type=script&lang=js"

import "./ChallengeInfo.vue?vue&type=style&index=0&id=11749456&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11749456"]])

export default __exports__